import { t } from 'i18next';
import { truckModeEnum } from '../truck';

export const truckModeLabels: Record<number, string> = {
    [truckModeEnum.APPRO]: 'appro',
    [truckModeEnum.EVAC]: 'evac',
    [truckModeEnum.TRANSFER]: 'transfer',
    [truckModeEnum.ONSITE]: 'onsite',
    [truckModeEnum.ENLEVEMENT]: 'enlevement',
    [truckModeEnum.POSE]: 'pose',
    [truckModeEnum.ROTATION]: 'rotation',
    [truckModeEnum.DOUBLEFRET]: 'doubleFret',
    [truckModeEnum.BACKANDFORTH]: 'backAndForth',
};

export const truckModeIcons: Record<number, { family: string; name: string }> = {
    [truckModeEnum.APPRO]: { family: 'MaterialCommunityIcons', name: 'arrow-down-right-bold' },
    [truckModeEnum.EVAC]: { family: 'MaterialCommunityIcons', name: 'arrow-right-top-bold' },
    [truckModeEnum.TRANSFER]: { family: 'MaterialCommunityIcons', name: 'transfer-right' },
    [truckModeEnum.ONSITE]: { family: 'FontAwesome6', name: 'arrows-spin' },
    [truckModeEnum.POSE]: { family: 'MaterialCommunityIcons', name: 'arrow-expand-down' },
    [truckModeEnum.ENLEVEMENT]: { family: 'MaterialCommunityIcons', name: 'arrow-expand-up' },
    [truckModeEnum.ROTATION]: { family: 'FontAwesome6', name: 'arrow-down-up-across-line' },
    [truckModeEnum.DOUBLEFRET]: { family: 'FontAwesome', name: 'exchange' },
    [truckModeEnum.BACKANDFORTH]: { family: 'MaterialCommunityIcons', name: 'arrow-u-left-bottom-bold' },
};

export const getTruckModeLabel = (mode?: number): string => {
    return mode !== undefined && truckModeLabels[mode] ? t(truckModeLabels[mode]) : '';
};

export const getTruckModeIcon = (mode: number) => {
    return truckModeIcons[mode] ?? { family: '', name: '' };
};
